import React, { useState } from "react";
import {
  Box,
  IconButton,
  Radio,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { getCols } from "../getCols";
import { onClickCell } from "./onClickCell";
import { useBidContext } from "../../Bid.context";
import ChatBtn from "./ChatBtn";
// import DocsBtn from "./DocsBtn";
import DocsBtnMenu from "./DocsBtnMenu";
import CopyAndVisitIconsBtns from "../../../../../../../../../components/btns/CopyAndVisitIconsBtns";

import DescriptionIcon from "@mui/icons-material/Description";

import { useParams } from "react-router-dom";
import VendorDataSheetModal from "../../../Components/TrimListDataSheet/VendorDataSheetModal";
export default function BidTableBody() {
  const { plantId } = useParams();
  const {
    mrqData,
    BidTableRows,
    setBidTableRows,
    selectedBidVendors,
    setOpenChatVendorIndex,
  } = useBidContext();

  const rows = BidTableRows || mrqData?.BidTableRows;
  console.log("rows bidRowsss", rows?.[0]);

  // const rawData = {
  //   Component: "Ball Valve",
  //   Size: "3/4",
  //   Category: "Valve",
  //   "Body Construction": "2-Piece",
  //   "Body Material": "ASTM A216 WCB",
  //   "Client Name": "DXPE",
  //   "Client Project Number": "001",
  //   "Design Pressure (kPa)": "40",
  //   "Design Temperature (°C)": "200",
  //   "EPCM Company Name": "DXPE",
  //   "EPCM Project Number": "002",
  //   Ends: "Screwed x SW",
  //   "External Coating": "No",
  //   "Firesafe Required": "Yes",
  //   "Fluid Phase": "F",
  //   "Insulation Thk": "2",
  //   "Line Number": 'FG-01-03K-2"-IN-ET',
  //   Material: "A350-LF2 CL.1",
  //   "Max Design Pressure Kpag": "900",
  //   "Max Design Temperature C": "200",
  //   "Operating Pressure (kPa)": "10",
  //   "Operating Temperature (°C)": "60",
  //   "P&ID Number": "0001",
  //   PandID: "001",
  //   "Port Pattern": "Full Port",
  //   "Project Name": "Keyra",
  //   "Schedule/Rating": "600",
  //   "Seat Elastomer": "PTFE",
  //   Service: "Fuel Gas",
  //   Spec: "03K",
  //   "Stem Ball Mounting": "Floating",
  //   "Test Pressure (kPa)": "20",
  //   "Trim Material": "SS316",
  //   "Upset Pressure (kPa)": "22",
  //   "Upset Temperature (°C)": "56",
  //   "Valve Operator": "Lever",
  //   path: "G:\\QCAD\\ChinookDT 01\\ChinookDT Demo\\1\\ChinookDT Smart P&ID.dxf",
  //   dataSheet: {
  //     "Client Information": {
  //       "Project Name": "Keyra",
  //       "Client Name": "DXPE",
  //       "Client Project Number": "001",
  //       "EPCM Company Name": "DXPE",
  //       "EPCM Project Number": "002",
  //     },
  //     "Process Data": {
  //       "Max Design Pressure Kpag": "900",
  //       "Max Design Temperature C": "200",
  //     },
  //     "Tag & Line Information": {
  //       "P&ID Number": "0001",
  //       "Tag Number": "B06X3A-4",
  //       "Line Number": 'FG-01-03K-2"-IN-ET',
  //       Spec: "03K",
  //       Service: "Fuel Gas",
  //       "Service Description": "",
  //     },
  //     "Piping Spec": {
  //       Component: "Ball Valve",
  //       Size: "3/4",
  //       "Schedule/Rating": "600",
  //       Ends: "Screwed x SW",
  //       Material: "A350-LF2 CL.1",
  //       "Material Description": "",
  //     },
  //     "Mechanical Specifications": {
  //       "Port Pattern": "Full Port",
  //       "Body Construction": "2-Piece",
  //       "Stem Ball Mounting": "Floating",
  //       "Body Material": "ASTM A216 WCB",
  //       "Trim Material": "SS316",
  //       "Seat Elastomer": "PTFE",
  //       "Valve Operator": "Lever",
  //       "External Coating": "No",
  //       "Firesafe Required": "Yes",
  //     },
  //     "Manufacturer & Notes": {
  //       Manufacturer: "",
  //       "Model Number": "",
  //       Notes: "",
  //     },
  //   },
  //   "Material Description":
  //     'BALL VALVE, 3/4", CL600, Screwed x SW, A350-LF2 CL.1',
  //   quantity: 1,
  // };
  const [currentDataSheet, setCurrentDataSheet] = React.useState({});
  const [openVendorDataSheet, setOpenVendorDataSheet] = React.useState(false);

  const handleOpenVendorDataSheet = () => setOpenVendorDataSheet(true);
  const handleCloseVendorDataSheet = () => setOpenVendorDataSheet(false);

  const onClickVendorDataSheet = (row, col) => {
    // get material specs
    console.log({ row, col });
    setCurrentDataSheet({
      ...row?.material?.specs,
      // ...rawData,
      vendorName: col.id,
      row,
      time: row[col.id]?.time,
      cost: row[col.id]?.cost,
      submittedDataSheet: row[col.id]?.submittedDataSheet,
    });
    handleOpenVendorDataSheet();
  };

  return (
    <>
      <TableBody>
        {rows?.map((row, index) => {
          return (
            <TableRow role="checkbox" tabIndex={-1} key={index}>
              {getCols(mrqData, selectedBidVendors)?.map((col) => {
                const value = row[col.id];
                return (
                  <TableCell
                    key={col.id}
                    align={col.align}
                    sx={{
                      alignItems:
                        (col.isVendor || col.id === "selected") && "center",

                      maxWidth:
                        col.id === "tagNumber"
                          ? 220
                          : col.id === "description"
                            ? 400
                            : "auto",
                      backgroundColor:
                        col.id === row?.selected?.name && "#890089",
                      padding: 1,
                      ":hover": col?.isVendor && {
                        backgroundColor: "#890089",
                        cursor: "pointer",
                      },
                      "& .hidden-button": {
                        opacity: col?.id === row?.selected?.name ? 1 : 0,
                      },
                      "&:hover .hidden-button": {
                        opacity: 1,
                      },
                    }}
                    onClick={() => {
                      onClickCell({
                        row,
                        col,
                        BidTableRows: rows,
                        setBidTableRows,
                        mrqData,
                        selectedBidVendors,
                      });
                    }}
                  >
                    {col.isVendor ? (
                      <div>
                        {col.id === "selected" && (
                          <div
                            style={{
                              display: "inline-block",
                              width: "25%",
                              fontWeight: 400,
                              borderRight: "1px solid #333",
                            }}
                          >
                            {value?.name ?? "-"}
                          </div>
                        )}
                        <div
                          style={{
                            display: "inline-block",
                            width: col.id === "selected" ? "25%" : "28%",
                            borderRight: "1px solid #333",
                            height: "100%",
                          }}
                        >
                          {value?.time ?? "-"}
                        </div>
                        <div
                          style={{
                            display: "inline-block",
                            width: col.id === "selected" ? "25%" : "28%",
                            borderRight: "1px solid #333",
                          }}
                        >
                          {value?.cost ?? "-"}
                        </div>
                        <div
                          style={{
                            display: "inline-block",
                            width: col.id === "selected" ? "25%" : "28%",
                          }}
                        >
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              onClickVendorDataSheet(row, col);
                            }}
                          >
                            <DescriptionIcon />
                          </IconButton>
                        </div>
                        <span
                          style={{
                            display: "inline-block",
                            width: "15%",
                          }}
                        >
                          <div className="hidden-button">
                            {col.isVendor && col.id !== "selected" && (
                              <Radio
                                checked={col.id === row?.selected?.name}
                                value="b"
                                disabled={
                                  !row[col.id]?.time && !row[col.id]?.cost
                                }
                                name={col.id + row.id}
                                inputProps={{ "aria-label": col.id }}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 18,
                                  },
                                }}
                              />
                            )}
                          </div>
                        </span>
                      </div>
                    ) : col.id === "id" ? (
                      index + 1
                    ) : col.id === "po" ? (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ mr: 0.5 }}>{row?.po} </Typography>
                        {row?.po && row?.poId && (
                          <CopyAndVisitIconsBtns
                            subLink={
                              `/projects/3/equipments/main_tank#main-nav=MCS&mcs-tab=PO%20Manager&po-id=` +
                              row?.poId
                            }
                          />
                        )}
                      </Box>
                    ) : (
                      value
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
        <TableRow role="checkbox" tabIndex={-1}>
          {getCols(mrqData, selectedBidVendors)?.map((col) => {
            return (
              <TableCell
                key={col.id}
                align={col.align}
                sx={{
                  alignItems: "center",
                  padding: 1,
                }}
              >
                {col.isVendor && col.id !== "selected" && (
                  <div>
                    <ChatBtn
                      mrqData={mrqData}
                      col={col}
                      setOpenChatVendorIndex={setOpenChatVendorIndex}
                      BidTableRows={BidTableRows}
                    />
                    {/* <DocsBtn /> */}
                    <DocsBtnMenu />
                  </div>
                )}
              </TableCell>
            );
          })}
        </TableRow>
      </TableBody>

      <VendorDataSheetModal
        currentDataSheet={currentDataSheet}
        open={openVendorDataSheet}
        onClose={handleCloseVendorDataSheet}
        submittedDataSheet={currentDataSheet?.submittedDataSheet}
      />
    </>
  );
}
